/**
 * Centralized Theme System for PCKM Mobile
 * Provides consistent colors, spacing, typography, shadows, and animations
 */

import {
  animations,
  borderRadius,
  colors,
  opacity,
  shadows,
  spacing,
  typography,
} from '../../design-tokens';

export { animations, borderRadius, colors, opacity, shadows, spacing, typography };

// Export as default theme object
export const theme = {
  colors,
  spacing,
  typography,
  borderRadius,
  shadows,
  animations,
  opacity,
};

export type Theme = typeof theme;
